export enum IRoles {
  NEWEMPLOYEE = 'cc9395e2-2a31-94b6-b71e-0f27c5e21aad',
  SUPERIOR = '77b8db64-fb94-f5e7-8758-2b27d08ace2b',
  EMPLOYEE = '03b9c8f8-2ecb-294f-7e4b-96d4b9c1e98a',
  BUDDY = 'e245b68f-b500-6d98-7cdf-b4a5d2542a7f',
  ADMINISTRATOR = '51c27b7b-e12e-dcfe-d76b-dc68926d4f7b',
  HR = '8d634cfd-f8a5-025d-5963-f99fe90b1b1a',
  CANDIDATE = 'c7febe25-3a03-fea9-ec4a-5a586d4e1366',
}
